import { useState } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/lib/cn";
import { favicon, siteName } from "@/shared/lib/sites";

const tile = cva("shrink-0 grid place-items-center overflow-hidden ring-1 ring-[var(--hairline)]", {
  variants: {
    // a source chip's 18px, or a site line's 16px (a citation's card, a source card)
    size: { chip: "w-[18px] h-[18px] rounded-[5px]", line: "w-4 h-4 rounded-[4px]" },
  },
  defaultVariants: { size: "chip" },
});

/** A web source's favicon on a white tile, its site's first letter when it has none. */
export default function SiteIcon({ url, site, size }: { url: string; site: string } & VariantProps<typeof tile>) {
  const [broken, setBroken] = useState(false);
  const src = broken ? null : favicon(url);
  return (
    <span aria-hidden className={cn(tile({ size }), src ? "bg-white" : "bg-[var(--surface)]")}>
      {src ? (
        <img src={src} alt="" loading="lazy" referrerPolicy="no-referrer" className="w-full h-full" onError={() => setBroken(true)} />
      ) : (
        <span className="text-[10px] font-semibold uppercase text-[var(--text-secondary)]">{siteName(site)[0]}</span>
      )}
    </span>
  );
}
